import React, { useEffect, useState } from 'react';
import './LoginNew.css';
import { useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { set_company_code_login, set_password_login, set_user_name } from './loginFormNewSlice';
import { finalLoginAPICall, searchUserByUSerNameAPICall } from '../../API/Login/LoginAPI';
import { checkDeviceAPI, requestDeviceOTPAPI, verifyDeviceOTPAPI } from '../../API/Login/DeviceAuthAPI';
import { getDeviceId } from '../../Js/deviceFingerprint';
import db from '../../offline/db';
import LoginForm from './LoginForm';
import LoginFormMobile from './LoginFormMobile';
import ForgotPassword from './ForgotPassword';
import img1 from './../../Assets/Images/4521601.png';
import img2 from './../../Assets/Images/BNFGH.png';
import img3 from './../../Assets/Images/TYERT.png';
import EyetLogo from '../../Assets/Images/Logo.png';
import ThalipeLogo from '../../Assets/Images/ThalipeLogo.png';
import ThalipeLogoBlk from '../../Assets/Images/Thali-Pe-updated-Png-123.png';
import { errorSnackMsg } from '../Custom Hooks/SnackkBarUtilities';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { update_search_user_response } from '../../Redux/Login/searchUserSlice';
import { update_userRole } from '../../Redux/Login/userRoleSlice';

const LoginNew = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isMobile = useMediaQuery('(max-width:768px)');
  const { companyCode, userName, password } = useSelector(state => state.loginFormNewSlice || {});
  const userRole = useSelector(state => state.searchUserSlice.value);
  const isAuth = localStorage.getItem("isAuth");
  const selfUser = localStorage.getItem("selfUser");

  const [imageOrder, setImageOrder] = useState([img1, img2, img3]);
  const [deviceId, setDeviceId] = useState(null);
  const [showOtpDialog, setShowOtpDialog] = useState(false);
  const [maskedEmail, setMaskedEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showForgotPasswordDialog, setShowForgotPasswordDialog] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [otpSecondsLeft, setOtpSecondsLeft] = useState(0);
  const [resendLoading, setResendLoading] = useState(false);

  // Initialize device ID and clear auth cache for security
  useEffect(() => {
    const initDeviceId = async () => {
      // Clear all user-specific cached data to prevent cross-user contamination
      try {
        await db.clearAllUserCache();
      } catch (e) {
        console.error('Error clearing user cache:', e);
      }
      
      const id = await getDeviceId();
      setDeviceId(id);
    };
    initDeviceId();
  }, []);

  // Helpers for OTP timer and resend
  const formatTime = (s) => {
    const mm = String(Math.floor(s / 60)).padStart(2, '0');
    const ss = String(s % 60).padStart(2, '0');
    return `${mm}:${ss}`;
  };

  const handleResendOtp = async () => {
    if (resendLoading) return;
    setResendLoading(true);
    try {
      await requestDeviceOTPAPI({ userName, companyCode, deviceId, prefix: 'RST' });
      setOtp('');
      setOtpSecondsLeft(120);
    } catch (e) {
      // errorSnackMsg handled in API util already
    } finally {
      setResendLoading(false);
    }
  };

  // Start/stop OTP countdown when dialog visibility changes
  useEffect(() => {
    if (!showOtpDialog) return;
    if (otpSecondsLeft <= 0) return;
    const timer = setInterval(() => {
      setOtpSecondsLeft((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [showOtpDialog, otpSecondsLeft]);

  // Handle image rotation
  const handleImageClick = (clickedIndex) => {
    const newOrder = [...imageOrder];
    if (clickedIndex === 0) {
      newOrder[0] = imageOrder[1];
      newOrder[1] = imageOrder[0];
    } else if (clickedIndex === 2) {
      newOrder[2] = imageOrder[0];
      newOrder[0] = imageOrder[1];
    }
    setImageOrder(newOrder);
  };

  const userRoleClearFn=()=>{
    dispatch(update_search_user_response({ searchUserData: undefined }));
    localStorage.setItem("userRole", null);
    dispatch(update_userRole({ userRole: undefined }));
  }
  // Handle input change for companyCode, userName, password
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'companyCode') {
      dispatch(set_company_code_login(value));
      userRoleClearFn()
    } else if (name === 'userName') {
      dispatch(set_user_name(value));
      userRoleClearFn()
    } else if (name === 'password') {
      dispatch(set_password_login(value));
    }
  };
  
  // Handle next button click
  const handleNextClick = () => {
    searchUserByUSerNameAPICall({ userName,companyCode, prefix: 'RST' },userRoleClearFn);
  };

  // Handle login submission with device verification
  const clickLoginBtn = async () => {
    if(password==="" || !password){
      errorSnackMsg("Password can't be empty !!");
      return;
    }

    setLoginLoading(true);

    // Check device verification for admin users
    if (userRole?.role === "admin" && deviceId) {
      try {
        const deviceCheck = await checkDeviceAPI({
          userName,
          companyCode,
          deviceId,
          prefix: "RST",
        });

        if (deviceCheck.needsVerification) {
          // Device needs verification - request OTP
          setMaskedEmail(deviceCheck.email);
          
          // Request OTP to be sent
          try {
            await requestDeviceOTPAPI({
              userName,
              companyCode,
              deviceId,
              prefix: "RST",
            });
            setShowOtpDialog(true);
            setOtpSecondsLeft(120);
            setLoginLoading(false);
          } catch (err) {
            errorSnackMsg("Failed to send OTP. Please try again.");
            setLoginLoading(false);
          }
          return;
        } else if (deviceCheck.needsEmailSetup) {
          errorSnackMsg("Please setup registered email in settings for enhanced security");
          setLoginLoading(false);
        }
      } catch (err) {
        console.error("Device check error:", err);
        // Continue with login even if device check fails
      }
    }

    try {
      const loginResult = await finalLoginAPICall({ userName, password, companyCode, prefix: 'RST', deviceId });
      if (loginResult?.error && loginResult?.showForgotPassword) {
        setShowForgotPassword(true);
      } else {
        setShowForgotPassword(false);
      }
    } finally {
      setLoginLoading(false);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setImageOrder(prevOrder => [prevOrder[2], prevOrder[0], prevOrder[1]]);
    }, 2000);
    return () => clearInterval(intervalId);
  }, []);

 //Redirect to userDashboard if user already logged in
 useEffect(() => {
  if (isAuth) {
    successAlert()
    const portableMode = localStorage.getItem("portableMode");
    setTimeout(()=>{
      if (portableMode === "true") {
        // Set portable mode to active and redirect to portable screen
        localStorage.setItem("portableMode", "active");
        navigate("/userdashboard/portable");
      } else if (selfUser) {
        navigate("/userDashBoard/selfOrder");
      } else {
        localStorage.removeItem("portableMode");
        navigate("/userdashboard/dashboardhome");
      }
    },1500)
  }
}, [isAuth]);



  //Success Message When Logged in Successfully
  const successAlert = () => {
    Swal.fire({
      title: "Logged in",
      text: "User authorized successfully",
      icon: "success",
      showConfirmButton: false,
      timer: 1500,
    });
  };
  // Handle OTP verification
  const handleVerifyOtp = async () => {
    if (!otp || otp.length !== 6) {
      errorSnackMsg("Please enter a valid 6-digit OTP");
      return;
    }

    try {
      // Verify OTP and add device to trusted list
      const deviceName = `${navigator.platform} - ${navigator.userAgent.match(/Chrome|Firefox|Safari|Edge/)?.[0] || 'Browser'}`;
      
      await verifyDeviceOTPAPI({
        userName,
        companyCode,
        deviceId,
        otp,
        prefix: "RST",
        deviceName
      });
      
      // OTP verified successfully - close dialog and proceed with login
      setShowOtpDialog(false);
      setOtp('');
      finalLoginAPICall({ userName, password, companyCode, prefix: 'RST', deviceId });
    } catch (err) {
      errorSnackMsg("Invalid OTP. Please try again.");
    }
  };

  const ImageCarousel = () => (
    <div className="image-scroll-container">
      {imageOrder.map((image, index) => (
        <div
          key={index}
          className={`image-item ${index === 1 ? 'center' : ''}`}
          onClick={() => handleImageClick(index)}
          style={{ backgroundImage: `url(${image})` }}
        />
      ))}
    </div>
  );

  return (
    <div className='login-new-main-container'>
     <div className={isMobile ? 'login-new-header-container-mobile' : 'login-new-header-container'} style={{ justifyContent: isMobile ? 'center' : 'space-between' }}>

    {/* <img className="logo" src={EyetLogo} alt="EYET logo" />    */}

    <img className="rest-logo" src={ThalipeLogoBlk} alt="Thalipe logo" />
    
    {!isMobile && userRole?.logo && <img className="rest-logo" src={userRole?.logo} alt="REST logo" />}
</div>

      <div className='login-new-container'>
        {isMobile ? (
          <div className='login-ctn-mobile-bg'>
            <LoginFormMobile
              onChangeFn={handleInputChange}
              handleNextClick={handleNextClick}
              clickLoginBtn={clickLoginBtn}
              loginLoading={loginLoading}
              showForgotPassword={showForgotPassword}
              onForgotPasswordClick={() => setShowForgotPasswordDialog(true)}
            />
            <ImageCarousel/>
          </div>
        ) : (
          <>
            <LoginForm
              onChangeFn={handleInputChange}
              handleNextClick={handleNextClick}
              clickLoginBtn={clickLoginBtn}
              loginLoading={loginLoading}
              showForgotPassword={showForgotPassword}
              onForgotPasswordClick={() => setShowForgotPasswordDialog(true)}
            />
            <div className='login-new-main-right-container'>
              <ImageCarousel/>
            </div>
          </>
        )}
      </div>

      {/* OTP Verification Dialog */}
      {showOtpDialog && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '8px',
            maxWidth: '400px',
            width: '90%'
          }}>
            <h2 style={{ marginBottom: '12px', textAlign: 'center', color: '#0b6b45' }}>Device Verification</h2>
            <p style={{ marginBottom: 8, color: '#666', textAlign: 'center' }}>OTP has been sent to {maskedEmail}</p>
            {otpSecondsLeft > 0 ? (
              <p style={{ marginBottom: 16, color: '#0b6b45', textAlign: 'center', fontWeight: 600 }}>
                Expires in {formatTime(otpSecondsLeft)}
              </p>
            ) : (
              <p style={{ marginBottom: 16, color: '#cc0000', textAlign: 'center', fontWeight: 600 }}>
                OTP expired. Please resend.
              </p>
            )}
            <input
              type="text"
              inputMode="numeric"
              pattern="\\d*"
              autoFocus
              placeholder="Enter 6-digit OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\\D/g, '').slice(0, 6))}
              style={{
                width: '100%',
                padding: '14px 16px',
                fontSize: '18px',
                fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
                border: '1px solid #dcdcdc',
                borderRadius: '8px',
                margin: '0 auto 20px',
                textAlign: 'center',
                letterSpacing: '6px',
                boxSizing: 'border-box',
                backgroundColor: '#ffffff',
                outline: 'none'
              }}
              maxLength={6}
            />
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
              <button
                onClick={() => {
                  setShowOtpDialog(false);
                  setOtp('');
                }}
                style={{
                  flex: 1,
                  padding: '12px 16px',
                  backgroundColor: '#f0f0f0',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  height: 44,
                  fontWeight: 600
                }}
              >
                Cancel
              </button>
              {otpSecondsLeft > 0 ? (
                <button
                  onClick={handleVerifyOtp}
                  disabled={otp.length !== 6}
                  style={{
                    flex: 1,
                    padding: '12px 16px',
                    backgroundColor: otp.length === 6 ? '#4CAF50' : '#9e9e9e',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: otp.length === 6 ? 'pointer' : 'not-allowed',
                    height: 44,
                    fontWeight: 600
                  }}
                >
                  Verify
                </button>
              ) : (
                <button
                  onClick={handleResendOtp}
                  disabled={resendLoading}
                  style={{
                    flex: 1,
                    padding: '12px 16px',
                    backgroundColor: resendLoading ? '#9e9e9e' : '#1976D2',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: resendLoading ? 'not-allowed' : 'pointer',
                    height: 44,
                    fontWeight: 600
                  }}
                >
                  {resendLoading ? 'Resending…' : 'Resend OTP'}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Forgot Password Dialog */}
      {showForgotPasswordDialog && (
        <ForgotPassword
          userName={userName}
          companyCode={companyCode}
          onClose={() => setShowForgotPasswordDialog(false)}
          onSuccess={() => {
            setShowForgotPassword(false);
            dispatch(set_password_login(''));
          }}
        />
      )}
 </div>
  );
};

export default LoginNew;
